import {
    Button,
    Dropdown,
    IconButton,
    Stack,
    Text,
    Textarea,
    useDisclosure,
} from '@adamdotai/design-system'
import type { IconProps } from '@adamdotai/design-system/src/components/Icon'
import { useTranslations } from 'next-intl'
import { useRef } from 'react'

type FeedbackButtonProps = {
    icon: React.ComponentType<IconProps>
    onSubmit: (text: string) => void
}

export const FeedbackButton = ({
    icon: Icon,
    onSubmit,
}: FeedbackButtonProps) => {
    const t = useTranslations()
    const textAreaRef = useRef<HTMLTextAreaElement>(undefined)
    const dropdown = useDisclosure()
    const onSend = () => {
        onSubmit(textAreaRef.current.value)
        textAreaRef.current.value = ''
        dropdown.onClose()
    }
    return (
        <Dropdown isOpen={dropdown.isOpen} onClose={dropdown.onClose}>
            <IconButton
                tooltipProps={{ label: t('meetingroom.send-feedback') }}
                as={Dropdown.Button}
                onClick={dropdown.onOpen}
            >
                <Icon />
            </IconButton>
            <Dropdown.List mt="2">
                <Stack px="5" py="4" spacing="6">
                    <Stack spacing="3">
                        <Text size="body1" fontWeight="bold">
                            {t('meetingroom.send-feedback')}
                        </Text>
                        <Textarea
                            minW="79"
                            rows={1}
                            placeholder="Tell us more how it can be improved (optional)"
                            ref={textAreaRef}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault()
                                    onSend()
                                }
                            }}
                        />
                    </Stack>
                    <Button size="sm" onClick={onSend} alignSelf="end">
                        Send
                    </Button>
                </Stack>
            </Dropdown.List>
        </Dropdown>
    )
}
